import { render } from "./MinhaArea.vue?vue&type=template&id=1788cd3c&scoped=true"
import script from "./MinhaArea.vue?vue&type=script&lang=js"
export * from "./MinhaArea.vue?vue&type=script&lang=js"

import "./MinhaArea.vue?vue&type=style&index=0&id=1788cd3c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1788cd3c"]])

export default __exports__